export class UnexpectedError extends Error {
    constructor(msg?: string) {
        super(msg || 'An unexpected error occurred.');
    }
}
